// Отображение текста с ограничением длины и тултипом (если длина текста больше лимита)
import React from "react";
import { Tooltip } from "antd";
import { limitText } from "../../lib/utils/limitText";
import { AnyObject } from "../../lib/interfaces";

interface SpanLimitTextProps {
  text?: string;
  limit: number;
  style?: AnyObject;
}

export const SpanLimitText = (props: SpanLimitTextProps) => {
  const { limit, text = "", style = {} } = props;

  const title = text.length > limit ? text : undefined;

  if (title) {
    return (
      <Tooltip title={title}>
        <span style={style}>{limitText(text, limit)}</span>
      </Tooltip>
    );
  }
  return <span style={style}>{text}</span>;
};
